import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, Routes, Route, Navigate } from "react-router-dom";
import { useAuthState } from "react-firebase-hooks/auth";
import CircularProgress from "@mui/material/CircularProgress";

import { firebaseAuth } from "../../components/firebase/auth";
import DashBoard from "../dashboard/Dashboard";
import { dashboardGroups, DEFAULT_DASHBOARD_PATH } from "../dashboard/dashboardRoutes";
import Farms from "../farms/Farms";
import LabelsNew from "../labels/LabelsNew";
import DashboardNew from "../dashboardNew/DashboardNew";
import Grows from "../grows/Grows";
import Devices from "../devices/Devices";
import Plants from "../plants/Plants";
import Products from "../products/Products";
import Batches from "../batches/Batches";

// Owner
import OwnerStart from "../owner/OwnerStart";

import "../../App.css";

function Start() {
  const [user, loading] = useAuthState(firebaseAuth);
  const navigate = useNavigate();
  const location = useLocation();

  const [authLoading, setAuthLoading] = useState(true);

  useEffect(() => {
    if (user === null && loading === false) {
      navigate("/login", { replace: true, state: { from: location.pathname } });
      setAuthLoading(false);
    } else if (user !== null && loading === false) {
      setAuthLoading(false);
    }
  }, [loading, user, navigate, location.pathname]);

  return (
    <div className="App">
      {authLoading || !user ? <CircularProgress color="inherit" /> : (
        <Routes>
          <Route path="/" element={<Navigate to={DEFAULT_DASHBOARD_PATH} replace />} />
          {dashboardGroups.map((group) => <Route key={`${group.id}-index`} path={group.id} element={<Navigate to={`/${group.id}/${group.tabs[0].slug}`} replace />} />)}
          {dashboardGroups.map((group) => <Route key={group.id} path={`${group.id}/:tab`} element={<DashBoard />} />)}
          <Route path="webshop/:tab/:id" element={<DashBoard />} />
          <Route path="webshop/*" element={<DashBoard />} />
          <Route path="dashboard" element={<DashboardNew />} />
          <Route path="farms" element={<Farms />} />
          <Route path="grows" element={<Grows />} />
          <Route path="devices" element={<Devices />} />
          <Route path="plants" element={<Plants />} />
          <Route path="products" element={<Products />} />
          <Route path="batches" element={<Batches />} />
          <Route path="labels" element={<LabelsNew />} />
          <Route path="sweden" element={<Navigate to={DEFAULT_DASHBOARD_PATH} replace />} />
          <Route path="owner/*" element={<OwnerStart />} />
        </Routes>
      )}
    </div>
  );
}

export default Start;
